<template>
	<div class='search-contract-wrap'>
			<div class="search-title">
				已为您按照
				<span>“{{contractNumber}}”</span>筛选合同，共筛选出<span>&nbsp;{{total}}&nbsp;</span>条数据
			</div>
			<ul class="wrap-border">
				<li v-for="item in list" :key="item.id">
					<router-link :to="`/contract/contractDetail/${item.id}`" tag="a">
						<div class="flex" :title="item.contractNumber">
							<p>{{item.contractName}}</p>
						</div>
					</router-link>
				</li>
			</ul>
			<div class="page-wrap">
				<el-pagination background layout="total, prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange" />
			</div>
	</div>
</template>

<script>
import { getContracts } from '@/api';
export default {
	components: {
	},
	data() {
		return {
      contractNumber: undefined,
			list: [],
			total: 0,
			pageSize: 10
		}
	},
	created() { },
	mounted() {},
	methods: {
		getNewsSearch(page = 1) {
			getContracts({ contractNumber: this.contractNumber, current: page }).then(res => {
				// console.log(res);
				const { total, records, size, current } = res;
				this.$set(this, 'total', total || 0);
				this.$set(this, 'pageSize', size || 10);
				this.$set(this, 'list', records || []);
			})
		},
		handleCurrentChange(e) {
			this.getNewsSearch(e)
		},
	},
	computed: {},
	watch: {
		$route: {
			handler(v) {
				const { query: { contractNumber } } = v;
				if (contractNumber) {
					this.$set(this, 'contractNumber', contractNumber);
					this.getNewsSearch()
				}
			},
			deep: true,
			immediate: true
		},
	},
}
</script>
<style lang='scss'>
	.search-contract-wrap {
			& > .search-title {
				text-indent: 16px;
				font-size: 16px;
				line-height: 34px;
				text-align: left;
				& > span {
					color: $red;
				}
			}
			& > .page-wrap {
				padding: 40px 0;
				text-align: right;
			}
			& > .wrap-border {
				padding: 0 16px;
				& > li {
					padding: 22px 6px 12px;
                	border-bottom: 1px solid #e5e9ec;
                	text-align: left;
					&:last-child {
						border: none;
					}
					& > a {
						& > .flex {
							margin-bottom: 10px;
							& > p {
								font-size: 15px;
                            	font-weight: 600;
                            	cursor: pointer;
                            	height: 16px;
                            	line-height: 16px;
                            	padding: 0 5px;
                            	vertical-align: text-bottom;
							}
						}
					}
				}
			}
	}
</style>
